import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      d: "M12.847 17.34a.521.521 0 0 1-.737.737L6.902 12.87a.52.52 0 0 1 0-.737l5.208-5.209a.521.521 0 0 1 .737.737l-4.84 4.84z"
    }, null, -1)
  ])))
}
export default { render: render }